import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  private isInitialized = false;

  constructor() {
    this.init();
  }

  private init(): void {
    if (!this.isInitialized) {
      posthog.init('phc_z2EAVyacTjfkALEPegsy29GnrT8QKWe39pqfsXoEHCBa', {
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'always',
      });
      this.isInitialized = true;
    }
  }

  track(eventName: string, properties?: any): void {
    if (this.isInitialized) {
      posthog.capture(eventName, properties);
    }
  }

  identify(userId: string, properties?: any): void {
    if (this.isInitialized) {
      posthog.identify(userId, properties);
    }
  }

  setUserProperties(properties: any): void {
    if (this.isInitialized) {
      posthog.setPersonProperties(properties);
    }
  }

  reset(): void {
    if (this.isInitialized) {
      posthog.reset();
    }
  }
}
